export default "__VITE_ASSET__CRjG0p4N__"